<p-breadcrumb class="max-w-full" [model]="items">
  <ng-template #item let-item>
    @if(item.routerLink){
    <a [routerLink]="item.routerLink" class="p-breadcrumb-item-link">
      <span class="font-semibold text-sm text-light-100 mb-1 hover:underline">
        {{ item.label }}
      </span>
    </a>
    } @else {
    <div class="mb-1">
      <span class="font-semibold text-sm text-light-60">
        {{ item.label }}
      </span>
    </div>
    }
  </ng-template>
</p-breadcrumb>
